import { useState } from 'react';
import { OperationsTable, OperationsTableProps } from './table';
import { OperationsFilters } from './filters';
import { OperationItem, OperationsFiltersValue } from '../../config';
import { DataContainer } from '@acme/foundation';
import { useNavigate } from 'react-router-dom';
import { AppRoutes, BaseRoute } from '@shared/routes';

type OperationsTabProps = OperationsTableProps<OperationItem>;

export const OperationsTab = (props: OperationsTabProps) => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState<OperationsFiltersValue>({
    search: '',
    period: { start: null, end: null },
    type: 'all',
  });

  return (
    <div className="flex flex-col gap-4">
      <DataContainer
        className="min-h-[624px]"
        empty={{
          view: false,
          title: (
            <div className="max-w-[348px]">
              Здесь будет отображаться информация о ваших операциях с заявками
            </div>
          ),
          message: 'У вас пока нет заявок',
          button: {
            title: 'Создать заявку',
            onClick: () => {
              navigate((AppRoutes.application.create as BaseRoute).path);
            },
          },
        }}
      >
        <OperationsFilters
          className="px-4"
          value={filters}
          onChange={setFilters}
        />

        <OperationsTable columns={props.columns} method={props.method} />
      </DataContainer>
    </div>
  );
};
